import axios from "axios";
import { getToken } from "./token";

const http = axios.create({
  baseURL: '',
  timeout: 10000
});

http.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config
}, (error) => {
  return Promise.reject(error);
})


http.interceptors.response.use((response) => {
  return response.data;
}, error => {
  if (error.response?.status === 401) {
    window.location.href='/login'
  }
  return Promise.reject(error);
})

export default http;